<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          PRODUCT HIERARCHY
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            {{ id ? 'Edit Product Hierarchy' : 'Create New Product Hierarchy' }}
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="clear" title="refresh">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Code"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Code</label>
                  <v-text-field
                    id="code"
                    single-line
                    outlined
                    placeholder="Code"
                    dense
                    label="Code"
                    v-model="items.code"
                    required
                    class="px-5"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Brand"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Brand</label>
                  <v-autocomplete
                    id="brand"
                    single-line
                    outlined
                    placeholder="Select Brand"
                    dense
                    v-model="items.brand_id"
                    required
                    class="px-5"
                    :items="itemsBrand"
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Name"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Name</label>
                  <v-text-field
                    id="name"
                    single-line
                    outlined
                    placeholder="Name"
                    dense
                    v-model="items.material_desc"
                    class="px-5"
                    :success="valid"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Stage"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Stage</label>
                  <v-autocomplete
                    id="stage"
                    single-line
                    outlined
                    placeholder="Select Stage"
                    dense
                    v-model="items.stage_id"
                    required
                    class="px-5"
                    :items="itemsStage"
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-4">
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'productHierarchy' }"
                >
                  Cancel
                </v-btn>
              </v-flex>
              <v-flex xs2 right>
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  type="submit"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { 'progress-dialog': ProgressDialog },
  props: ['id'],
  data() {
    return {
      items: {
        code: '',
        material_desc: '',
        brand_id: null,
        stage_id: null
      },
      loading: true,
      progressDialogLoading: true,
      search: '',
      itemsEntity: [],
      itemsBrand: [],
      itemsVariant: [],
      itemsStage: [],
      itemsType: [],
      itemsFlavor: [],
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Product Hierarchy List',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: this.id
            ? 'Edit Product Hierarchy'
            : 'Create New Product Hierarchy',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  mounted() {
    this.getBrand();
    this.getStage();
    if (this.id) {
      this.getDetail();
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 500);
    }
  },
  methods: {
    getStage() {
      const limit = 100;
      this.$store
        .dispatch('productHierarchy/getStage', { limit })
        .then(data => {
          if (data.code === 200) {
            this.itemsStage = data.data.result;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getBrand() {
      const limit = 100;
      this.$store
        .dispatch('brand/getAll', { limit })
        .then(data => {
          if (data.code === 200) {
            this.itemsBrand = data.data.result;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('productHierarchy/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async clear() {
      this.items = {
        code: '',
        material_desc: '',
        entity_id: null,
        brand_id: null,
        variant_id: null,
        stage_id: null,
        stage_type_id: null,
        flavor_id: null
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        if (this.id) {
          this.$store
            .dispatch('productHierarchy/update', {
              id: this.id,
              params: this.items
            })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'productHierarchy'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          this.$store
            .dispatch('productHierarchy/create', this.items)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'productHierarchy'
                });
              } else {
                Swal.fire('Failed!', data.data.message.text_en, 'error');
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      }
    }
  }
};
</script>
